import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import * as $ from 'jquery';
import { SeedReservationService } from '../../../../../../src/app/services/seed/seed-reservation.service';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { forkJoin } from 'rxjs';
import { SeedReservationReconciliationService } from '../../../../services/seed/seed-reservation-reconciliation.service';
@Component({
  selector: 'app-seed-reservation-reconcile-create',
  templateUrl: './seed-reservation-reconcile-create.component.html',
  styleUrl: './seed-reservation-reconcile-create.component.scss'
})
export class SeedReservationReconcileCreateComponent implements OnInit, OnDestroy {
  // ===============================
  // ✅ Primitive Type Variables
  // ===============================
  showTabs = false;
  shipToDataLoading: boolean = true;
  hasChangeAdded = false;
  isPlaceOrderDisable = true;
  isNotValid = false;
  isAddingNewItem = false;
  readOnlyAccess = false;
  selectedCount = 0;
  searchCount = 0;
  dataCount = 0;
  isUpdateRequest: boolean = false;
  tabNode: '';
  newItemName = '';
  emailAddress: string;
  duplicateCombinationError: string;
  selectedMarketingBrand: string;
  selectedProductLine: string;
  selectedreservationUnits = 0;
  pendingReservationUnits = 0;
  seedReservationDetailId = 0;

  // ===============================
  // ✅ Array Type Variables
  // ===============================e
  subscription = new Array<Subscription>();
  productList: any[] = [];
  marketingBrandList: any[] = [];
  updatedProductList: any[] = [];
  updatedMarketingBrandList: any[] = [];
  ddldeliveryList = [
    { id: 'Y', value: 'Yes' },
    { id: 'N', value: 'No' }
  ];
  selectedItems: any[] = [];
  newItemList: any[] = [];
  seedReservationDataSource: any[] = [];
  displayedColumns: string[] = ['select', 'productLine', 'marketingBrand', 'reservationUnits', 'growerUnits', 'longShort', 'pendingReservtionUnits'];

  // ===============================
  // ✅ Object / Any Type Variables
  // ===============================
  shipToData: any;
  userMenuAccessList: any;
  formdata: any;
  growerLoading: any;
  growerList: any;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  shipToAccount: any;
  selectedProductLineId: any;
  selectedMarketingBrandId: any;
  reservationData: any;
  headerId: any;
  isInMobileApp = false;
  enableItemLevelButton = false;
  enableHybridLevelButton = false;

  // ===============================
  // ✅ Constant / Class Instances
  // ===============================
  dashboardFilter: DashboardFilter;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  expandedElement: any;
  isConversionEligible: boolean = true;
  isB2BAccount: boolean;
  hasActiveKNOrder: boolean;
  isConversionBlockedConfigLevel: boolean = false;
  isConversionBlockedReservationLevel: boolean = false;

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    public sliderModelService: SliderModelService,
    public seedReservationService: SeedReservationService,
    public seedReservationReconciliationService: SeedReservationReconciliationService,
    public seedReplantService: SeedReplantService) {
    this.dashboardFilter = new DashboardFilter();
    //this.addReservationRow();
  }

  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.isInMobileApp = this.isInWebView();
    this.setDefaultformData()
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_RESERVATION)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_RESERVATION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.subscription.push(this.seedReservationService.seedReservationId.subscribe(x => {
            if (x[0] && x[0] != 0) {
              this.isUpdateRequest = x[1];
              this.getOrderDetails(x[0]);
            } else {
              //this.readOnlyAccess = !x[1];
              this.router.navigate(['/seed-reservation-landing']);
            }
          }));
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }

  }

  //ngAfterViewInit() {
  //  this.setTableHeight();
  //  this.setHeight();
  //}

  //@HostListener('window:resize', ['$event']) onresize(event) {
  //  this.setTableHeight();
  //  this.setHeight();
  //}

  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }

  //setHeight() {
  //  if (window.innerWidth < 767) {
  //    const templateHeight = window.innerHeight - 200;
  //    $('.productLabelFormPage').css('max-height', templateHeight + 'px');
  //  }
  //}

  //setTableHeight() {
  //  setTimeout(function () {
  //    const templateMinHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 190;
  //    const templateMaxHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 189;

  //    $('.tableOuterContainer').css('min-height', templateMinHeight + 'px');
  //    $('.tableOuterContainer').css('max-height', templateMaxHeight + 'px');
  //  }, 100);
  //}

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  setDefaultformData() {
    this.formdata = {
      accountNumber: null,
      accountName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      overNightDelivery: "N",
      orderedBy: null,
      accountManager: null,
      attn: null,
      email: null,
      customerPO: null,
      orderedDate: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      cppproductLabelItems: []
    };
  }


  OpenAddProductSlider() {
    if (this.selectedMarketingBrand && this.selectedProductLine && this.reservationData.shipTo && this.seedReservationDetailId > 0) {
      const marketingBrand = this.selectedMarketingBrand;
      const productLine = this.selectedProductLine;
      const accountNo = this.reservationData?.shipTo;

      this.sliderModelService.setSeedReservationReconcileChangeVal({
        companyCode: this.headerCompany,
        cropYear: +this.headerYear,
        accountNo: +accountNo,
        marketingBrand: marketingBrand.toUpperCase(),
        productLine: productLine.toUpperCase(),
        action: '',
        data: [],
        dealerData: [],
        page: 'growerOrder',
        isAccountRIB: false,
        shipToName: this.reservationData?.shipToName || '',
        shipToAccountAddress1 : this.reservationData?.shipToAccountAddress1 || '',
        shipToCity : this.reservationData?.shipToCity || '',
        shipToState : this.reservationData?.shipToState || '',
        shipToZipCode : this.reservationData?.shipToZipCode || '',
        seedReservationDetailId: this.seedReservationDetailId,
        seedReservationHeaderID: this.headerId,
        shipToContact: this.reservationData?.shipToContact || '',
        sellerName: this.reservationData?.salesRepresentativeAccountName || '',
        sellerAccountNo: +this.reservationData?.salesRepresentativeAccountNo,
        growerOrderNumber: '',
        growerOrderId: 0,
        gmk: this.reservationData?.gmk,
        marketingBrandId: this.selectedMarketingBrandId,
        productLineId: this.selectedProductLineId,
        isParentGMK: this.reservationData?.isParentChildGMK,
        reservationUnits: +this.selectedreservationUnits,
        pendingReservationUnits: +this.pendingReservationUnits
      });
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
      this.sliderModelService.activeSlider('seedReservationReconcileSlider');
    }
  }


  OpenAddHybridProductSlider() {
    if (this.selectedMarketingBrand && this.selectedProductLine && this.reservationData.shipTo && this.seedReservationDetailId > 0) {
      const marketingBrand = this.selectedMarketingBrand;
      const productLine = this.selectedProductLine;
      const accountNo = this.reservationData?.shipTo;

      this.sliderModelService.setSeedReservationReconcileChangeVal({
        companyCode: this.headerCompany,
        cropYear: +this.headerYear,
        accountNo: +accountNo,
        marketingBrand: marketingBrand.toUpperCase(),
        productLine: productLine.toUpperCase(),
        action: '',
        data: [],
        dealerData: [],
        page: 'growerOrder',
        isAccountRIB: false,
        shipToName: this.reservationData?.shipToName || '',
        shipToAccountAddress1: this.reservationData?.shipToAccountAddress1 || '',
        shipToCity: this.reservationData?.shipToCity || '',
        shipToState: this.reservationData?.shipToState || '',
        shipToZipCode: this.reservationData?.shipToZipCode || '',
        seedReservationDetailId: this.seedReservationDetailId,
        seedReservationHeaderID: this.headerId,
        shipToContact: this.reservationData?.shipToContact || '',
        sellerName: this.reservationData?.salesRepresentativeAccountName || '',
        sellerAccountNo: +this.reservationData?.salesRepresentativeAccountNo,
        growerOrderNumber: '',
        growerOrderId: 0,
        gmk: this.reservationData?.gmk,
        marketingBrandId: this.selectedMarketingBrandId,
        productLineId: this.selectedProductLineId,
        isParentGMK: this.reservationData?.isParentChildGMK,
        reservationUnits: +this.selectedreservationUnits,
        pendingReservationUnits: +this.pendingReservationUnits
      });
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
      this.sliderModelService.activeSlider('seedReservationReconcileHybridSlider');
    }
  }

  getOrderDetails(seedReservationId: number) {
    this.loaderService.setLoaderStatus(true);

    const confirmation$ = this.seedReservationReconciliationService.getConfirmationData(seedReservationId);
    const masterData$ = this.seedReservationService.getSeedReservationMasterData(true);

    this.subscription.push(
      forkJoin([confirmation$, masterData$]).subscribe(
        ([confirmationResult, masterDataResult]: any[]) => {
          this.productList = masterDataResult.productLines;
          this.marketingBrandList = masterDataResult.marketingBrands;
          this.updatedProductList = masterDataResult.forUpdateProductLines;
          this.updatedMarketingBrandList = masterDataResult.forUpdateMarketingBrand;
          this.reservationData = confirmationResult;
          this.headerId = confirmationResult.seedReservationHeaderID;
          this.hasActiveKNOrder = confirmationResult.hasActiveKNOrder;
          this.isB2BAccount = confirmationResult.isB2BAccount;

          //if (this.hasActiveKNOrder || this.isB2BAccount) {
          //  this.isConversionEligible = false;
          //  //this.displayedColumns = ['productLine', 'marketingBrand', 'reservationUnits', 'growerUnits', 'longShort', 'pendingReservtionUnits'];
          // }
          // else {
          //   //this.displayedColumns = ['select', 'productLine', 'marketingBrand', 'reservationUnits', 'growerUnits', 'longShort', 'pendingReservtionUnits'];
          //}

          this.selectedItems = [];

          confirmationResult.productDetails.forEach(x => {
            const productLine = this.updatedProductList.find(item => item.id === x.productLineId);
            const marketingBrand = this.updatedMarketingBrandList.find(item => item.id === x.marketingBrandId);
            this.selectedItems.push({
              seedReservationDetailId: x.seedReservationDetailId,
              productLineId: x.productLineId,
              productLineName: productLine ? productLine.value : '',
              marketingBrandId: x.marketingBrandId,
              marketingBrandName: marketingBrand ? marketingBrand.value : '',
              reservationUnits: x.reservationUnits,
              growerUnits: x.growerUnits || 0,
              longUnits: x.longUnits || 0,
              pendingReservationUnits: x.pendingReservationUnits || 0,
              growerDetails: x.growerDetails && x.growerDetails.length > 0 ? x.growerDetails : [],
              growerReservationOrders: x.growerReservationOrders && x.growerReservationOrders.length > 0 ? x.growerReservationOrders : [],
              showAllGrowerDetails: false,
              selected: false,
              isEditable: x.isEditable || false,
              isItemLevelConversionEnabled: x.isItemLevelConversionEnabled || false,
              isHybridLevelConversionEnabled: x.isHybridLevelConversionEnabled || false
            });
          });

          this.seedReservationDataSource = [...this.selectedItems];
          this.selectedProductLineId = this.selectedItems.length > 0
            ? this.selectedItems[this.selectedItems.length - 1].productLineId
            : null;
          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
          LolLoggerService.error(error);
        }
      )
    );
  }

  enableCheckBoxSingle(isChecked, element) {
    this.isUpdateRequest = true;
    if (isChecked) {
      // Clear errors from all items first
      this.seedReservationDataSource.filter(x => x.seedReservationDetailId !== element.seedReservationDetailId && x.selected)
        .forEach(x => {
          x.selected = false;
          x.hasError = false;
          x.errorMessage = '';
        });

      if (this.isB2BAccount || this.hasActiveKNOrder){
        this.showErrorAtLineLevel(element);
      }
      else if (element.pendingReservationUnits > 0) {
        this.selectedMarketingBrand = element.marketingBrandName;
        this.selectedProductLine = element.productLineName;
        this.selectedreservationUnits = +element.reservationUnits;
        this.pendingReservationUnits = +element.pendingReservationUnits;
        this.seedReservationDetailId = +element.seedReservationDetailId;
        this.selectedMarketingBrandId = element.marketingBrandId;
        this.selectedProductLineId = element.productLineId;
        if (!element.isItemLevelConversionEnabled && !element.isHybridLevelConversionEnabled) {
          this.showErrorAtLineLevel(element);
        }
        else {
          if (element.isItemLevelConversionEnabled) {
            this.enableItemLevelButton = true;
            this.isConversionBlockedConfigLevel = false;
          }
          else {
            this.enableItemLevelButton = false;
          }
          if (element.isHybridLevelConversionEnabled) {
            this.enableHybridLevelButton = true;
            this.isConversionBlockedConfigLevel = false;
          }
          else {
            this.enableHybridLevelButton = false;
          }
        }
        
      }
      else if(element.pendingReservationUnits === 0){
         this.showErrorAtLineLevel(element);
      }
      else {
        this.enableItemLevelButton = false;
        this.enableHybridLevelButton = false;
        this.isConversionBlockedReservationLevel = true;
      }  
    }
    else {
      this.selectedMarketingBrand = null;
      this.selectedProductLine = null;
      this.selectedreservationUnits = 0;
      this.pendingReservationUnits = 0;
      this.selectedMarketingBrandId = null;
      this.selectedProductLineId = null;
      this.seedReservationDetailId = 0;
      
      element.hasError = false;
      element.errorMessage = '';
      element.selected = false;

      this.isConversionBlockedConfigLevel = false;
      this.isConversionBlockedReservationLevel = false;
      this.enableItemLevelButton = false;  
      this.enableHybridLevelButton = false;

    }
  }

  showErrorAtLineLevel(element){
    element.hasError = true;
    element.errorMessage = 'Conversion is not available for the selected product line and marketing brand';
    this.enableItemLevelButton = false;
    this.isConversionBlockedConfigLevel = true;
    this.enableHybridLevelButton = false;
  }
  onNavigate(url) {
    window.open(url, '_blank');
  }

  redirectToOrder(rowData: any) {

    let orderType, accountNo, orderId;
    orderType = rowData.orderType;
    accountNo = this.reservationData?.shipTo;
    orderId = rowData.growerOrderId;

    if (rowData.isClickable && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/grower-order-detail' + '/0' + '/' + orderId);
    }

  }

  navigateTolandingPage() {
    if (this.hasChangeAdded && this.isUpdateRequest) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No,go Back to Reservation ', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
          closebutton.style.display = '';
          this.sliderModelService.close();
          this.router.navigate(['/seed-reservation-landing']);
        }
      });
    }
    else {
      const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
      closebutton.style.display = '';
      this.sliderModelService.close();
      this.router.navigate(['/seed-reservation-landing']);
    }
  }


  showAddNewItemInput() {
    this.isAddingNewItem = true;
    // this.setTableHeight();
  }



  hasAnyError(): boolean {
    return this.seedReservationDataSource?.some(item => item.hasError);
  }

  isFormValid(): boolean {
    return this.selectedItems.every(item => {
      if (item.quantity === 0) {
        return true;
      }
      return !!item.productLineId && !!item.marketingBrandId;
    });
  }

  toggleExpandRow(element: any) {
    if (this.expandedElement === element) {
      this.expandedElement = null;
    } else {
      element.showAllGrowerDetails = false;
      this.expandedElement = element;
    }
  }

  toggleShowAllGrowerDetails(element: any) {
    element.showAllGrowerDetails = !element.showAllGrowerDetails;
  }

  navigateToGrowerOrder(element: any) {
    this.router.navigate(['/seed-reservation/seed-reservation-reconcile-grower-order']);
  }

  navigateToCreate() {
    this.router.navigate(['/seed-reservation/seed-reservation-create']);
  }

  get tooltipMessage(): string {
    if (this.isConversionBlockedReservationLevel || this.isConversionBlockedConfigLevel || this.isB2BAccount || this.hasActiveKNOrder) {
      return 'This option is not available';
    }

    //if (this.isConversionBlockedReservationLevel) {
    //  return 'Conversion is not available';
    //}

    //if (this.isConversionBlockedConfigLevel) {
    //  return 'This option is not available';
    //}

    //if (this.isB2BAccount) {
    //  return 'Conversion is not available. This account is configured for B2B ordering.';
    //}

    //if (this.hasActiveKNOrder) {
    //  return 'Conversion is not available. An active B2B (KN) grower order exists for this account and crop year.';
    //}

    return '';
  }
}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
